import { TextField } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import { withStyles } from "@material-ui/core/styles";
import { DatePicker } from "@material-ui/pickers";
import { makeStyles } from "@material-ui/styles";
import { getErrorMessage, isError } from "libs/utils/form";
import React from "react";
import { useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";

const StyleCheckbox = withStyles((theme) => ({
  root: {
    borderRadius: 6,
    color: "#8898aa",
    "&$checked": {
      color: theme.palette.success.main,
    },
  },
  checked: {},
}))(Checkbox);

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    display: "flex",
    flex: 1,
  },
}));

export default function ContractTermSection({ formik, isSmartForm = false }) {
  const classes = useStyles();

  const isYearMonth = formik.values?.ContractTermType === "Y";
  const isPeriod = formik.values?.ContractTermType === "P";
  const isOther = formik.values?.ContractTermType === "O";
  const canEdit = useSelector(canEditForm);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: !isSmartForm ? "row" : "column",
      }}
    >
      <FormGroup row={isSmartForm}>
        <FormControlLabel
          control={
            <StyleCheckbox
              disabled={!canEdit}
              name="Year"
              checked={isYearMonth}
              onChange={() => formik.setFieldValue("ContractTermType", "Y")}
            />
          }
          label="Year - Months"
        />
        <FormControlLabel
          control={
            <StyleCheckbox
              disabled={!canEdit}
              name="Period (dd-mm-yyyy to dd-mm-yyyy)"
              checked={isPeriod}
              onChange={() => formik.setFieldValue("ContractTermType", "P")}
            />
          }
          label="Period"
        />
        <FormControlLabel
          control={
            <StyleCheckbox
              disabled={!canEdit}
              name="Other"
              checked={isOther}
              onChange={() => formik.setFieldValue("ContractTermType", "O")}
            />
          }
          label="Other ( Please specify )"
        />
      </FormGroup>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flex: 1,
        }}
      >
        {isYearMonth && (
          <>
            <TextField
              disabled={!canEdit}
              className={classes.formControl}
              variant="outlined"
              placeholder="Year"
              type="number"
              name="ContractYear"
              value={formik.values?.ContractYear}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={isError("ContractYear", formik)}
              helperText={getErrorMessage("ContractYear", formik)}
            />
            <TextField
              disabled={!canEdit}
              className={classes.formControl}
              variant="outlined"
              placeholder="Month"
              type="number"
              name="ContractMonth"
              value={formik.values?.ContractMonth}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={isError("ContractMonth", formik)}
              helperText={getErrorMessage("ContractMonth", formik)}
            />
          </>
        )}
        {isPeriod && (
          <>
            <DatePicker
              disabled={!canEdit}
              className={classes.formControl}
              inputVariant="outlined"
              disableFuture
              openTo="year"
              format="DD-MM-YYYY"
              label="Start date"
              views={["year", "month", "date"]}
              name="ContractPeriodFrom"
              value={formik.values?.ContractPeriodFrom || null}
              onChange={(date) => {
                formik.setFieldValue(
                  "ContractPeriodFrom",
                  date.format("YYYY-MM-DD")
                );
              }}
              error={isError("ContractPeriodFrom", formik)}
              helperText={getErrorMessage("ContractPeriodFrom", formik)}
            />
            <DatePicker
              disabled={!canEdit}
              className={classes.formControl}
              inputVariant="outlined"
              // disableFuture
              openTo="year"
              format="DD-MM-YYYY"
              label="End date"
              views={["year", "month", "date"]}
              name="ContractPeriodTo"
              value={formik.values?.ContractPeriodTo || null}
              onChange={(date) => {
                formik.setFieldValue(
                  "ContractPeriodTo",
                  date.format("YYYY-MM-DD")
                );
              }}
              error={isError("ContractPeriodTo", formik)}
              helperText={getErrorMessage("ContractPeriodTo", formik)}
            />
          </>
        )}
        {isOther && (
          <TextField
            disabled={!canEdit}
            className={classes.formControl}
            variant="outlined"
            placeholder="Please specify"
            name="ContractOther"
            value={formik.values?.ContractOther}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={isError("ContractOther", formik)}
            helperText={getErrorMessage("ContractOther", formik)}
          />
        )}
      </div>
    </div>
  );
}
